module.exports = __webpack_public_path__ + "images/company/rank_medal/average_seconds_to_initial_reply_rank/1_f8fea1179477496ae3493fa953720921.png";